module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "40",
      "height": "40",
      "viewBox": "0 0 40 40",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11 26.5963V17.6663C11 17.3371 11.0812 17.013 11.2364 16.7227C11.3917 16.4325 11.6162 16.185 11.89 16.0023L18.89 11.3363C19.2187 11.117 19.6049 11 20 11C20.3951 11 20.7813 11.117 21.11 11.3363L28.11 16.0023C28.3838 16.185 28.6083 16.4325 28.7636 16.7227C28.9188 17.013 29 17.3371 29 17.6663V26.5963M11 26.5963C11 27.1267 11.2107 27.6354 11.5858 28.0105C11.9609 28.3856 12.4696 28.5963 13 28.5963H27C27.5304 28.5963 28.0391 28.3856 28.4142 28.0105C28.7893 27.6354 29 27.1267 29 26.5963M11 26.5963L17.75 22.0963M29 26.5963L22.25 22.0963M17.75 22.0963L11 17.5963M17.75 22.0963L18.89 22.8563C19.2187 23.0756 19.6049 23.1926 20 23.1926C20.3951 23.1926 20.7813 23.0756 21.11 22.8563L22.25 22.0963M22.25 22.0963L29 17.5963",
      "stroke": "#3F3F46",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7f7b9fe","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppSvgIconNew/templates/icons/email.vue
// module id = a78ac42514f624f03aa8
// module chunks = 89